module.exports = __webpack_public_path__ + "static/media/icon_google_play_zh.6670cdd1.png";